import { render, staticRenderFns } from "./AS_HomeMobilePayment.vue?vue&type=template&id=44991bad&scoped=true&"
var script = {}
import style0 from "./AS_HomeMobilePayment.vue?vue&type=style&index=0&id=44991bad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44991bad",
  null
  
)

export default component.exports